import { enforce, create, test, only, omitWhen } from 'vest';
import 'vest/enforce/email';

export default create((currentField, data = {}, oper) => {

    only(currentField)

    test('name', 'Valor requerido', () => {
        enforce(data.name).isNotEmpty();
    })
    test('name', 'El nombre debe contener al menos 3 caracteres', () => {
        enforce(data.name).longerThanOrEquals(3);
    });
    test('email', 'Valor requerido', () => {
        enforce(data.email).isNotEmpty();
    })
    test('email', 'Email no valido', () => {
        enforce(data.email).isEmail();
    })
    omitWhen(oper === "edit", () => {
        test('password', 'Valor requerido', () => {
            enforce(data.password).isNotEmpty();
        })
        test('password', 'La contraseña debe tener al menos 8 caracteres', () => {
            enforce(data.password).longerThanOrEquals(8);
        })
        test('password_confirmation', 'Valor requerido', () => {
            enforce(data.password_confirmation).isNotEmpty();
        })
        test('password_confirmation', 'Las contraseñas deben coincidir', () => {
            enforce(data.password_confirmation).equals(data.password);
        })

    })

})
